module.exports = __webpack_public_path__ + "img/icon-checkup.3eeb4b39.svg";